export const GOOGLE_AUTH_ERROR_SEARCH_PARAM = 'googleAuthError'
